export default "__VITE_ASSET__BkjkApxd__"